module.exports = __webpack_public_path__ + "media/markers/club_pur-a3d58d2f.svg";